import { chartPointToPixel } from "../coordinateUtils";
import { createDrawingObject, replaceLastPoint } from "../shared";
export function calculateDisjointChannelGeometry(drawing, scales) {
    const [p0, p1, p2, p3] = drawing.points;
    if (!p0 || !p1 || !p2 || !p3)
        return null;
    const start1 = chartPointToPixel(p0, scales);
    const end1 = chartPointToPixel(p1, scales);
    const start2 = chartPointToPixel(p2, scales);
    const end2 = chartPointToPixel(p3, scales);
    // Check if the first line is still being drawn (p1 has not been set yet)
    const isFirstLineDrawing = p0.x === p1.x && p0.y === p1.y;
    if (isFirstLineDrawing) {
        return {
            upperLine: { start: start1, end: end2 }, // end2 is cursor
            lowerLine: { start: start1, end: start1 },
            gap: 0,
        };
    }
    // Check if the second line has not been started yet (p2 has not been set yet)
    const isSecondLineNotStarted = p0.x === p2.x && p0.y === p2.y;
    if (isSecondLineNotStarted) {
        return {
            upperLine: { start: start1, end: end1 },
            lowerLine: { start: end2, end: end2 }, // end2 is cursor
            gap: 0,
        };
    }
    // Both lines are defined or drawing
    const dx1 = end1.x - start1.x;
    const dy1 = end1.y - start1.y;
    const length1 = Math.sqrt(dx1 * dx1 + dy1 * dy1);
    let gap = 0;
    if (length1 > 0) {
        const nx = -dy1 / length1;
        const ny = dx1 / length1;
        gap = Math.abs((start2.x - start1.x) * nx + (start2.y - start1.y) * ny);
    }
    return {
        upperLine: { start: start1, end: end1 },
        lowerLine: { start: start2, end: end2 },
        gap,
    };
}
const DisjointChannel = {
    name: "disjointChannel",
    createDraft: (startPoint) => createDrawingObject("disjointChannel", [startPoint, startPoint, startPoint, startPoint]),
    updateDraft: (draft, nextPoint) => replaceLastPoint(draft, nextPoint),
    render: () => undefined,
};
export default DisjointChannel;
